const types = {
  FETCH_INVITERS_START: 'FETCH_INVITERS_START',
  FETCH_INVITERS_SUCCESS: 'FETCH_INVITERS_SUCCESS',
  FETCH_INVITERS_FAILURE: 'FETCH_INVITERS_FAILURE',
}

export default types
